import { render } from "./BaseRequestModal.vue?vue&type=template&id=f287eda0&scoped=true"
import script from "./BaseRequestModal.vue?vue&type=script&lang=js"
export * from "./BaseRequestModal.vue?vue&type=script&lang=js"

import "./BaseRequestModal.vue?vue&type=style&index=0&id=f287eda0&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f287eda0"]])

export default __exports__